export const ADD_NEW_CONTRACT = 'ADD_NEW_CONTRACT';
export const API_ADDRESS = 'https://rufflet-api.herokuapp.com';



// WEBPACK FOOTER //
// ./src/constants/app.js